import NumberFormat from 'react-number-format';

const NumberFormatCustom = (props: any) => {
  const {
    inputRef, onChange, ...other
  } = props;

  return (
    <NumberFormat
      {...other}
      getInputRef={inputRef}
      onValueChange={(values) => {
        onChange?.({
          target: {
            value: values.value
          }
        });
      }}
      thousandSeparator
      isNumericString
    />
  );
};


export default NumberFormatCustom;
